import { useEffect, useState } from 'react';
import { useAnalysis } from '../../utils/contexts/AnalysisContext';

export default function useTooltip({ pageName }) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(true);
  const { trackEvent, ANALYSIS_SEGMENT } = useAnalysis();
  const entryName = 'bb_page_tooltip';
  const pageIdentifier = pageName.toLowerCase().replace(/ /g, '_');

  const loadConfig = () => {
    const config = window.localStorage.getItem(entryName);
    return config !== null ? JSON.parse(config) : {};
  };

  const saveConfig = (config, value) => {
    const entryValue = {
      ...config,
      [pageIdentifier]: value
    };

    window.localStorage.setItem(entryName, JSON.stringify(entryValue));
    return value;
  };

  const getConfig = () => {
    const config = loadConfig();
    console.log(config);

    return config[pageIdentifier] !== undefined
      ? config[pageIdentifier]
      : saveConfig(config, true);
  };

  useEffect(() => {
    setIsTooltipOpen(getConfig());
  }, [pageName]);

  const onToggleTooltip = () => {
    // track event only if the tooltip is being toggled by the user.
    trackEvent(ANALYSIS_SEGMENT.SEGMENT_EVENTS.Info_Panel_Clicked, {
      page: pageName,
      status: isTooltipOpen ? 'closed' : 'opened'
    });

    saveConfig(loadConfig(), !isTooltipOpen);
    setIsTooltipOpen(!isTooltipOpen);
  };

  return { isTooltipOpen, onToggleTooltip };
}
